import { transition, trigger, useAnimation } from "@angular/animations";
import { slideCollapseAnimation, slideExpandAnimation } from "../animation/slide.animation";

export const slideTrigger = trigger('slide', [
    transition(':enter', [
        useAnimation(slideExpandAnimation)
    ]),

    transition(':leave', [
        useAnimation(slideCollapseAnimation)
    ])
])